import { cn } from '@/shared/lib';
import { Typography } from '@/shared/ui';

import { mockAvatars } from '../mock/mockAvatars';
import { AvatarCard } from './avatar-card';

interface AvatarsListProps {
  onSelectAvatar: (avatar: string) => void;
  testAvatar?: string;
  className?: string;
}

export const AvatarsList = ({
  onSelectAvatar,
  testAvatar,
  className,
}: AvatarsListProps) => {
  return (
    <div className={cn('flex w-full flex-col', className)}>
      <Typography
        color="text-base-100"
        className="px-4 py-5 text-center uppercase tracking-[0.3px]"
      >
        your presets
      </Typography>
      <div className="grid grid-cols-[1fr_1fr_1fr] gap-1">
        {mockAvatars.map((avatar) => (
          <AvatarCard
            avatar={avatar}
            isActive={avatar.imageSrc === testAvatar}
            key={avatar.name}
            onClick={() => {
              onSelectAvatar(avatar.imageSrc);
            }}
          />
        ))}
      </div>
    </div>
  );
};
